import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

const StockLocation = () => {
  return (
    <SettingsMetaData propertyName={"InventoryStockLocation"} viewPropertyName={" Stock Location"} />

  )
}

export default StockLocation